// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ReadFilledSvg from "@fishx/icons-svg/es/asn/ReadFilled";
import FishxIcon from '../components/FishxIcon';

var ReadFilled = function ReadFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: ReadFilledSvg
  }));
};

ReadFilled.displayName = 'ReadFilled';
export default React.forwardRef(ReadFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/ReadFilled.js
// module id = 3967
// module chunks = 0